import React from 'react';
import { Link } from 'react-router-dom';
import { BILLING_DESCRIPTOR } from '../constants/company';
import './PurchaseTerms.css';

/**
 * Refund, delivery, billing-descriptor, and support copy for signup.
 */
export function CheckoutPurchaseTerms({ supportEmail, className = '' }) {
  return (
    <div className={`purchase-terms ${className}`.trim()}>
      <p>
        This is a prepaid, one-time purchase of VPN access for the selected period.
        It is not a free trial, a membership, or an automatically renewing subscription.
        Access ends when the period expires; nothing is billed again unless you buy a new plan.
      </p>
      <p>
        Delivery is digital. After payment, VPN credentials and setup instructions are provided
        by email and on the confirmation page. No physical goods are shipped.
      </p>
      <p>
        All sales are final and non-refundable except where required by applicable law.
      </p>
      <p>
        Your card statement may show this charge as {BILLING_DESCRIPTOR} or a similar billing descriptor.
      </p>
      <p>
        Need help? Email <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
        {' or visit our '}
        <Link to="/contact">Contact page</Link>.
      </p>
    </div>
  );
}
